import { Attribute, DetailsHeader, Tooltip } from '@discretize/gw2-ui-new';
import {
  AssumedBuffs,
  Character,
} from '@discretize/react-discretize-components';
import InfoIcon from '@mui/icons-material/Info';
import {
  Button,
  ButtonGroup,
  FormControlLabel,
  Switch,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { ChangeEvent } from 'react';
import { makeStyles } from 'tss-react/mui';
import ThumbnailContext from '../../state/context/ThumbnailContext';
import Message from '../Message';

const useStyles = makeStyles()((theme) => ({
  buttonGroup: {
    marginBottom: theme.spacing(1),
  },
  text: {},
}));

const CustomSwitch = ({
  onChange,
  label,
}: {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  label: string;
}): JSX.Element => (
  <FormControlLabel control={<Switch onChange={onChange} />} label={label} />
);

function CharacterWithAr({
  characters,
}: {
  characters: {
    gear: React.ComponentProps<typeof Character>;
    title: string;
    children: React.ReactNode;
  }[];
}) {
  const { classes } = useStyles();

  const [selected, setSelected] = React.useState(0);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('lg'));

  const image = React.useContext(ThumbnailContext);
  const selectedCharacter = characters[selected] || characters[0];

  return (
    <>
      <ButtonGroup
        orientation={isSmall ? 'vertical' : 'horizontal'}
        className={classes.buttonGroup}
      >
        {characters.map(
          (character, index) =>
            character.gear.attributes && (
              <Button
                key={`character_${index.toString()}`}
                {...(selected === index
                  ? { variant: 'contained' }
                  : { variant: 'outlined' })}
                color="primary"
                onClick={() => setSelected(index)}
                style={{ height: 40 }}
              >
                <Tooltip
                  content={
                    <>
                      <DetailsHeader>
                        {character.title ||
                          `${character.gear.attributes.data['Agony Resistance']} Agony Resistance`}
                      </DetailsHeader>
                      {character.gear.assumedBuffs?.value && (
                        <Typography variant="body2">
                          Assumed Buffs:{' '}
                          <AssumedBuffs
                            value={character.gear.assumedBuffs.value}
                          />
                        </Typography>
                      )}
                    </>
                  }
                >
                  <span className={classes.text}>
                    <Attribute
                      name="Agony Resistance"
                      text={
                        character.title ||
                        `${character.gear.attributes.data['Agony Resistance']} Agony Resistance`
                      }
                      style={{
                        color: selected === index ? 'black' : 'inherit',
                      }}
                      disableLink
                      disableTooltip
                    />
                  </span>
                </Tooltip>
              </Button>
            ),
        )}
      </ButtonGroup>
      <div style={{ margin: 1 }}>
        {selectedCharacter.children && selectedCharacter.children !== '' && (
          <Message icon={InfoIcon}>{selectedCharacter.children}</Message>
        )}

        {image && (
          <Character
            {...selectedCharacter.gear}
            imageElement={
              <>
                <Typography sx={{ textAlign: 'center' }}>
                  Any item with the same stats may be used!
                </Typography>
                <GatsbyImage
                  image={image}
                  alt={`${selectedCharacter.gear?.attributes?.specialization}`}
                />
              </>
            }
            switchElement={CustomSwitch}
          />
        )}
      </div>
    </>
  );
}

export default CharacterWithAr;
